import {
  initializeEnterpriseFirebase,
  PUSH_SETUP_ERROR_CODES,
} from "@/common/lib/firebase";
import { firebaseConfig } from "@/lib/firebaseApp";

const isDev = process.env.NODE_ENV !== "production";
const appCheckSiteKey =
  process.env.VUE_APP_RECAPTCHA_SITE_KEY ||
  process.env.VITE_RECAPTCHA_SITE_KEY;
const appCheckDebugToken =
  process.env.VUE_APP_RECAPTCHA_DEBUG_TOKEN ||
  process.env.VITE_APPCHECK_DEBUG_TOKEN;

const firebaseRuntime = initializeEnterpriseFirebase({
  firebaseConfig,
  appCheckSiteKey,
  appCheckDebugToken,
  fcmVapidKey:
    process.env.VUE_APP_FCM_VAPID_KEY || process.env.VITE_FCM_VAPID_KEY,
  isDev,
  enableAnalytics: true,
});

const {
  analytics,
  app,
  appCheck,
  auth,
  db,
  ensureAppCheckToken,
  onFCMMessage,
  requestFCMToken,
  storage,
} = firebaseRuntime;

export {
  analytics,
  app,
  appCheck,
  auth,
  db,
  ensureAppCheckToken,
  firebaseConfig,
  onFCMMessage,
  PUSH_SETUP_ERROR_CODES,
  requestFCMToken,
  storage,
};
